import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ROUTES } from './data/constants';
import AuthProvider from './auth/AuthProvider';
import RequireAuth from './auth/RequireAuth';
import RequireAdmin from './auth/RequireAdmin';
import { CartProvider } from './cart/CartContext';
import CartDrawer from './cart/CartDrawer';
import CartIcon from './cart/CartIcon';
import Navbar from './components/Navbar';
import AcquisitionBanner from './components/AcquisitionBanner';
import Footer from './components/Footer';
import ErrorBoundary from './components/ErrorBoundary';
import Home from './pages/Home';
import Products from './pages/Products';
import ProductDetails from './pages/ProductDetails';
import Reviews from './pages/Reviews';
import Checkout from './pages/Checkout';
import OrderHistory from './pages/OrderHistory';
import OrderDetail from './pages/OrderDetail';
import AdminDashboard from './pages/admin/Dashboard';
import AdminOrders from './pages/admin/OrderManagement';
import AdminProducts from './pages/admin/ProductManagement';
import AdminReviews from './pages/admin/ReviewModeration';
import AdminDiscountCodes from './pages/admin/DiscountCodes';
import AgentDashboardDemo from './pages/admin/AgentDashboardDemo';
import './App.css';

const App: React.FC = () => {
  const [cartOpen, setCartOpen] = useState(false);

  return (
    <AuthProvider>
      <CartProvider>
        <Router>
          <div className="App">
            <AcquisitionBanner />
            <Navbar cartIcon={<CartIcon onClick={() => setCartOpen(true)} />} />
            <CartDrawer open={cartOpen} onClose={() => setCartOpen(false)} />
            <main className="main-content">
              <ErrorBoundary>
                <Routes>
                  <Route path={ROUTES.HOME} element={<Home />} />
                  <Route path={ROUTES.PRODUCTS} element={<Products />} />
                  <Route path="/product/:id" element={<ProductDetails />} />
                  <Route path={ROUTES.REVIEWS} element={<Reviews />} />
                  <Route path="/checkout" element={<RequireAuth><Checkout /></RequireAuth>} />
                  <Route path="/orders" element={<RequireAuth><OrderHistory /></RequireAuth>} />
                  <Route path="/orders/:id" element={<RequireAuth><OrderDetail /></RequireAuth>} />
                  <Route path="/admin" element={<RequireAdmin><AdminDashboard /></RequireAdmin>} />
                  <Route path="/admin/orders" element={<RequireAdmin><AdminOrders /></RequireAdmin>} />
                  <Route path="/admin/products" element={<RequireAdmin><AdminProducts /></RequireAdmin>} />
                  <Route path="/admin/reviews" element={<RequireAdmin><AdminReviews /></RequireAdmin>} />
                  <Route path="/admin/discounts" element={<RequireAdmin><AdminDiscountCodes /></RequireAdmin>} />
                  <Route path="/admin/agent-dashboard" element={<RequireAdmin><AgentDashboardDemo /></RequireAdmin>} />
                </Routes>
              </ErrorBoundary>
            </main>
            <Footer />
          </div>
        </Router>
      </CartProvider>
    </AuthProvider>
  );
};

export default App;
